/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  useSubmitError.js
 */

import type { FormikContextType } from 'formik'
import { useEffect } from 'react'

import type { Values } from '../MessageForm/helpers'

export interface SubmitErrorProps {
  formik: FormikContextType<Values>
  onSubmitError: () => void
}
export const useSubmitError = ({ formik, onSubmitError }: SubmitErrorProps) => {
  useEffect(() => {
    if (formik?.isSubmitting && !formik?.isValid) {
      onSubmitError()
    }
  })
}
